import { createApiClient } from "toptaal-shared"
import { useAuthStore } from "@/stores/useAuthStore"
import { router } from "@/main"

const apiClient = createApiClient({
  authStore: useAuthStore.getState(),
  onLogout: () => {
    router.navigate({ to: "/login", replace: true })
  },
  apiUrl: import.meta.env.VITE_API_URL,
})

export default apiClient
